import React, { Fragment } from 'react';
import { useCountdown, TimeLeft } from '../hooks/useCountdown';
const labels: {
  key: keyof TimeLeft;
  label: string;
}[] = [{
  key: 'hours',
  label: 'horas'
}, {
  key: 'minutes',
  label: 'minutos'
}, {
  key: 'seconds',
  label: 'segundos'
}];
export function CountdownTimer() {
  const time = useCountdown();
  return <div className="flex items-center justify-center gap-2 sm:gap-4" data-id="element-50">
      {labels.map(({
      key,
      label
    }, i) => <Fragment key={key} data-id="element-51">
          <div className="flex flex-col items-center" data-id="element-52">
            <div className="rounded-lg bg-black border border-white/10 px-3 py-3 sm:px-5 sm:py-4 min-w-[64px] sm:min-w-[88px] text-center" aria-label={`${time[key]} ${label}`} data-id="element-53">
              <span className="font-display text-3xl sm:text-5xl font-bold text-white tabular-nums" data-id="element-54">
                {time[key]}
              </span>
            </div>
            <span className="mt-2 text-xs text-white/50 uppercase tracking-wide" data-id="element-55">
              {label}
            </span>
          </div>
          {i < labels.length - 1 && <span className="text-2xl sm:text-4xl font-bold text-white/40 pb-6" data-id="element-56">
              :
            </span>}
        </Fragment>)}
    </div>;
}